import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {
    ITimeSpentReminderWithBalanceComponentProps
} from "../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/time-spent-reminder-options";
import {TimeSpentReminderComponentBaseProps} from "../with-dropdown/time-spent-reminder-with-dropdown.component";
import React, {ReactNode} from "react";
import {TsrWithBalanceBox} from "./boxes/tsr-with-balance.box";
import { DialogTextBox, DialogHighlightedTextBox } from "../../modal-dialog/boxes/text/dialog-text.box";
import { ModalDialogActionsComponent } from "../../modal-dialog/modal-dialog-actions.component";

export type TimeSpentReminderWithBalanceProps = ITimeSpentReminderWithBalanceComponentProps & TimeSpentReminderComponentBaseProps;

export class TimeSpentReminderWithBalanceComponent extends OrbitComponent<TimeSpentReminderWithBalanceProps> {

    private _executeContinueButtonAction = () => {
      this.services.runningGame.continuePlayingCurrentGame();

      const analyticsAction = this.services.runningGame.isGameRunning ? 'continue_in_game' : 'continue_in_lobby';

      this.services.analytics.sendAnalytics('reality_check_message', analyticsAction);

      this.props.dialogHandler.close();
    };

    private _executeCloseGameButtonAction = () => {
        this.services.analytics.sendAnalytics('reality_check_message', 'close_game');

        this.services.runningGame.closeRunningGame();

        this.props.dialogHandler.close();
    };

    private _getFormattedSessionBalance = (): string => {
        let balanceAbsoluteValue = Math.abs(this.props.totalNetLoss);
        return this.services.currency.formatMoney(balanceAbsoluteValue, true);
    };

    private _getFormattedPlayingTime = (): string => {
        const playingTimeWithoutUnits = this.props.playingTime.toHoursAndMinutesString();
        //Temporary hack to also display 'h' and 'm', should probably modify TimeSpan class to support this
        return `${playingTimeWithoutUnits.substring(0, 2)}h${playingTimeWithoutUnits.substring(2)}m`;
    };

    private _getSessionBalanceText = (): string => {
      const translationKey = this.props.totalNetLoss < 0 ? "TSR_WINNINGS_TEXT" : "TSR_LOSSES_TEXT";
      return this.services.translation.translate(translationKey);
    };

    render = (): ReactNode => {
        return (
            <TsrWithBalanceBox>
                <DialogTextBox>{this.services.translation.translate("TSR_SESSION_TIME_TEXT")}</DialogTextBox>
                <DialogHighlightedTextBox>{this._getFormattedPlayingTime()}</DialogHighlightedTextBox>
                <DialogTextBox>{this._getSessionBalanceText()} </DialogTextBox>
                <DialogHighlightedTextBox>{this._getFormattedSessionBalance()}</DialogHighlightedTextBox>
                <ModalDialogActionsComponent primaryAction={{
                    onClick: this._executeContinueButtonAction,
                    text: this.services.translation.translate('TSR_CONFIRM')
                }} secondaryAction={this.props.isInGame ? {
                    onClick: this._executeCloseGameButtonAction,
                    text: this.services.translation.translate('TSR_CLOSE_GAME')
                } : null} buttonsOnSeparateLines={this.services.mediaQuery.lAndBelow} />
            </TsrWithBalanceBox>
        );
    }
}